export default "<a href ng-click=\"vm.download()\" ng-transclude angular-ripple></a> <progress></progress> ";